module.exports = __webpack_public_path__ + "static/media/ic-header-arrow.98221f9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-header-arrow.svg
// module id = 721
// module chunks = 0